var map = {
	"./404.svg": 32,
	"./bug.svg": 3473,
	"./chart.svg": 2106,
	"./clipboard.svg": 6139,
	"./component.svg": 2283,
	"./dashboard.svg": 570,
	"./documentation.svg": 7850,
	"./drag.svg": 4086,
	"./edit.svg": 4534,
	"./education.svg": 8158,
	"./email.svg": 9914,
	"./example.svg": 7893,
	"./excel.svg": 9187,
	"./exit-fullscreen.svg": 5874,
	"./eye-open.svg": 1181,
	"./eye.svg": 8431,
	"./form.svg": 2962,
	"./fullscreen.svg": 4320,
	"./guide.svg": 2044,
	"./icon.svg": 1275,
	"./international.svg": 6108,
	"./language.svg": 9364,
	"./link.svg": 9835,
	"./list.svg": 8790,
	"./lock.svg": 4946,
	"./message.svg": 9603,
	"./money.svg": 1910,
	"./nested.svg": 3593,
	"./password.svg": 4117,
	"./pdf.svg": 6900,
	"./people.svg": 1409,
	"./peoples.svg": 3831,
	"./qq.svg": 6377,
	"./search.svg": 5075,
	"./shopping.svg": 1966,
	"./size.svg": 6063,
	"./skill.svg": 5090,
	"./star.svg": 1312,
	"./tab.svg": 4706,
	"./table.svg": 5695,
	"./theme.svg": 1041,
	"./tree-table.svg": 8979,
	"./tree.svg": 9162,
	"./user.svg": 7798,
	"./wechat.svg": 6940,
	"./zip.svg": 4084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;